import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { Checkbox } from '../../ui/checkbox';
/**
 * Branded checkbox preserving the existing Radix contract, including form
 * `name`/`value`, controlled state, and `onCheckedChange`.
 */ export const SpecraCheckbox = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx(Checkbox, {
        className: cn('size-3.5 border-input data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground', className),
        ref: ref,
        ...props
    }));
SpecraCheckbox.displayName = 'SpecraCheckbox';
